import { Link, useParams } from 'react-router-dom';

const BG = '#0A0B14';
const TEXT = '#E2E8F0';
const MUTED = '#94A3B8';
const VIOLET = '#8B5CF6';
const VIOLET_LIGHT = '#A78BFA';
const FONT = "'DM Sans', system-ui, -apple-system, sans-serif";

// Describe each upcoming tool. Keyed by the URL slug.
const UPCOMING = {
  quizcard: {
    name: 'QuizCard',
    icon: '/icons/quizcard-256.png',
    tagline: 'AI flashcards and quizzes from your notes.',
    description: 'Paste your notes, get instant flashcards and quizzes. Study smarter, not longer.',
  },
  clearlens: {
    name: 'ClearLens',
    icon: '/icons/clearlens-256.png',
    tagline: 'Confusing concepts, explained clearly.',
    description: 'Drop in a topic, get a clean breakdown with examples — like having a tutor on demand.',
  },
};

export default function ComingSoon({ slug }) {
  const tool = UPCOMING[slug] || UPCOMING.quizcard;

  return (
    <div style={{
      minHeight: '100vh',
      background: BG,
      color: TEXT,
      fontFamily: FONT,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '32px 24px',
      textAlign: 'center',
    }}>
      <Link to="/" style={{
        position: 'absolute',
        top: 'calc(24px + env(safe-area-inset-top))',
        left: 'calc(24px + env(safe-area-inset-left))',
        color: VIOLET_LIGHT,
        textDecoration: 'none',
        fontSize: 14,
        fontWeight: 600,
      }}>
        ← NerdStack
      </Link>

      <img
        src={tool.icon}
        alt={tool.name}
        style={{
          width: 160,
          height: 160,
          marginBottom: 24,
          filter: 'blur(2px) saturate(0.8)',
          opacity: 0.7,
        }}
      />

      <div style={{
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 1.5,
        color: VIOLET_LIGHT,
        marginBottom: 12,
        textTransform: 'uppercase',
      }}>
        Launching soon
      </div>

      <h1 style={{
        margin: 0,
        fontSize: 'clamp(36px, 6vw, 56px)',
        fontWeight: 800,
        letterSpacing: -1,
      }}>
        {tool.name}
      </h1>

      <p style={{
        marginTop: 12,
        marginBottom: 8,
        fontSize: 'clamp(18px, 2.5vw, 22px)',
        color: VIOLET_LIGHT,
        fontWeight: 500,
      }}>
        {tool.tagline}
      </p>

      <p style={{
        marginTop: 16,
        maxWidth: 520,
        fontSize: 16,
        color: MUTED,
        lineHeight: 1.6,
      }}>
        {tool.description}
      </p>

      <Link
        to="/"
        style={{
          marginTop: 40,
          display: 'inline-block',
          padding: '14px 32px',
          background: VIOLET,
          color: 'white',
          borderRadius: 12,
          textDecoration: 'none',
          fontSize: 15,
          fontWeight: 600,
          transition: 'background 0.18s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = VIOLET_LIGHT; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = VIOLET; }}
      >
        Explore the free tools →
      </Link>
    </div>
  );
}
